const getMailDeleteHashId = () => {
  let deleteHashId = "";
  if (window.location.pathname.includes("/delete/")) {
    const pathArray = window.location.pathname.split("/");
    deleteHashId = pathArray[pathArray.length - 1];

    return deleteHashId;
  }

  return deleteHashId;
};

export default getMailDeleteHashId;
